export default "__VITE_ASSET__CMfi4HBR__"